module.exports = __webpack_public_path__ + "media/images/icons/rectangle_list-538b0e7adb780d9f41bfa5d75757fe9a.svg";